export type NavSection = 'home' | 'radio' | 'music' | 'explore' | 'library' | 'search' | 'premium'

// Active state follows the SECTION, not the page (PRD rule 3). Deeper pages light
// their parent; route names are the ones in src/router/routes.js.
const SECTIONS: Array<[NavSection, RegExp]> = [
    ['home', /^home$/],
    ['radio', /^channel(-index)?(\/|$)/],
    ['music', /^(browse\/mixes\/|mix$|artist(\/|$)|show(\/|$))/],
    ['explore', /^(browse\/(genres|charts|playlists)|genre$)/],
    ['library', /^your-library/],
    ['search', /^search(\/|$)/],
    ['premium', /^premium\//],
]

// Phones fold Music and Explore into Home (no tab for either — phone amendment 2026-09-10).
const PHONE_FOLD: Partial<Record<NavSection, NavSection>> = { music: 'home', explore: 'home' }

export function navSectionFor(routeName: string | null | undefined, { phone = false }: { phone?: boolean } = {}): NavSection | null {
    if (!routeName) return null
    const hit = SECTIONS.find(([, pattern]) => pattern.test(routeName))
    if (!hit) return null
    const section = hit[0]
    if (phone) return PHONE_FOLD[section] || section
    // Search is a field, not a destination, from the tablet tier up (PRD rule 2).
    return section === 'search' ? null : section
}
